import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import nurseImg from "../assets/hero-login.png";
import logo from "../assets/axis-backoffice.svg";
import { LoginForm } from "../components/LoginForm";
import { Container } from "react-bootstrap";

const Login = () => {
  const [errMsg, setErrMsg] = useState("");

  const navigate = useNavigate();

  return (
    <Fragment>
      <Row
        className={
          "row g-0 justify-content-center gradient-bottom-right bg-light-blue"
        }
      >
        <Col
          className={
            "col-md-6 col-lg-5 col-xl-5 position-fixed start-0 top-0 vh-100 overflow-y-hidden d-none d-lg-flex flex-md-column"
          }
        >
          <Row className={"p-12 py-xl-10 px-xl-20"}>
            <img
              src={logo}
              alt={"Axis Healthcare"}
              className={"d-block"}
              style={{ width: 170 }}
            />
            <h1
              className={
                "mt-16 text-axis-tight text-axis-offblack fw-bolder display-6 mb-5 mt-5"
              }
            >
              Ireland’s premier nursing recruitment agency.
            </h1>
          </Row>
          <Row className={"mt-auto ps-16 ps-xl-20"}>
            <img
              style={{ minWidth: "600px" }}
              src={nurseImg}
              alt={"Nurse"}
              className={"img-fluid w-100 rounded-top-start-4"}
            />
          </Row>
        </Col>
        <Col
          className={
            "col-12 col-md-12 col-lg-7 offset-lg-5 min-vh-100 overflow-y-auto d-flex flex-column justify-content-center position-relative bg-body rounded-top-start-lg-4 border-start-lg shadow-soft-5"
          }
        >
          <Container fluid className={"w-100"}>
            <Col className={"p-12"}>
              <LoginForm />
            </Col>
          </Container>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Login;
